module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Vessel.js"));
	}, "Vessel");
}